import { useSelector } from 'react-redux';
import { GAPageViewEvent, TUserAuth } from 'utils/analytics';
import { selectPageModelRegionId } from '../../store/pageModel/selectors';
import { getCookies, getPath } from '../../selectors';
import { useEffectOnce } from './use-effect-once';

export const usePageViewEvent = () => {
	const path = useSelector(getPath);
	const cityId = useSelector(selectPageModelRegionId);
	const cookies = useSelector(getCookies);
	const customerId = cookies?.customerId || null;
	const userAuth = cookies?.['user-auth'] === 'true' ? 1 : 0;

	useEffectOnce(() => {
		GAPageViewEvent({
			pagePath: path,
			userId: userAuth ? customerId : null,
			userAuth: String(userAuth) as TUserAuth,
			cityId,
		});
	});
};
